import { z } from 'zod';
import { moneySchema } from '../money';

/** Zahlung auf eine Rechnung (Debitor) oder Eingangsrechnung (Kreditor). */
export const createPaymentSchema = z.object({
  amount: moneySchema,
  paidAt: z.string().datetime().optional(),
  note: z.string().trim().max(500).optional(),
});
export type CreatePaymentInput = z.infer<typeof createPaymentSchema>;

export const paymentResponseSchema = z.object({
  id: z.string().uuid(),
  /** Beleg-ID (Debitor: SalesDocument, Kreditor: PurchaseOrder). */
  invoiceId: z.string().uuid(),
  invoiceNumber: z.string(),
  amount: moneySchema,
  paidAt: z.string().datetime(),
  note: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type PaymentResponse = z.infer<typeof paymentResponseSchema>;

/** Debitor (Forderung, Verkaufsrechnung) vs. Kreditor (Verbindlichkeit, Eingangsrechnung). */
export const openItemDirectionSchema = z.enum(['RECEIVABLE', 'PAYABLE']);
export type OpenItemDirection = z.infer<typeof openItemDirectionSchema>;

/** Offener Posten (OP-Liste): Beleg (Debitor/Kreditor) mit Zahlstand. */
export const openItemResponseSchema = z.object({
  /** Beleg-ID (Debitor: SalesDocument, Kreditor: PurchaseOrder EINGANGSRECHNUNG). */
  invoiceId: z.string().uuid(),
  direction: openItemDirectionSchema,
  /** Belegart als String (Verkauf: INVOICE/…, Einkauf: EINGANGSRECHNUNG). */
  kind: z.string(),
  number: z.string(),
  /** Kunde (Debitor) bzw. Lieferant (Kreditor). */
  partyName: z.string(),
  documentDate: z.string().datetime(),
  dueDate: z.string().datetime().nullable(),
  status: z.string(),
  gross: moneySchema,
  paid: moneySchema,
  open: moneySchema,
  isOverdue: z.boolean(),
});
export type OpenItemResponse = z.infer<typeof openItemResponseSchema>;
